export const OVERVIEW_PATH = "/overview";
export const EMPLOYEES_EOR_PATH = "/employees-eor";
export const CONTRACTORS_PATH = "/contractors";
export const EOR_PROMO_PATH = "/eor-promo";
